export const regionClassificationData = {
    "北海道・東北": ["010006","020001","030007","040002","050008","060003","070009"],
    "関東": ["080004","090000","100005","110001","120006","130001","140007"],
    "中部": ["150002","160008","170003","180009","190004","200000","210005","220001","230006"],
    "近畿": ["240001","250007","260002","270008","280003","290009","300004"],
    "中国・四国": ["310000","320005","330001","340006","350001","360007","370002","380008","390003"],
    "九州・沖縄": ["400009","410004","420000","430005","440001","450006","460001","470007"]
}